module.exports = __webpack_public_path__ + "static/Logo-8952754a6192a925a330df35126e77ab.png";